import HecRasHelper from "../../helpers/HecRasHelper";
import {useAppContext} from "../../context/AppContext";

export default function CheckCSName({csName, csNameVal,  csNameList = []}) {
    const {filter} = useAppContext()

    const getStyle = (cs_name) => {
        const type = filter?.type
        if(type === 'highlight') {
            return {
                color: HecRasHelper.inFilter({us: filter?.us, ds: filter?.ds, cs_name}) ? '#00a8ff' : '',
            }
        }
        else {
            return {
                color: ''
            }
        }
    }

    if(csName) {
        return (
            <span className={'cross-section-name'} style={{...getStyle(csNameVal || csName)}}>
                {csName}
            </span>
        )
    }

    if(csNameList) {
        return csNameList.map((cs_name, idx) => (
            <>
                <span className={'cross-section-name'} style={{...getStyle(cs_name?.csNameVal || cs_name)}}>
                    {typeof cs_name === 'object' ? cs_name?.csName : cs_name}
                </span>
                {idx < csNameList.length-1 && (', ')}
            </>
        ))
    }
}